






import { Component, Vue } from 'vue-property-decorator'
import { CommonMudule } from './store/modules/common'
// import { visitSave } from '@/api/dataObservation'
// import { sessionSetItem, sessionGetItem } from '@/utils/baseFn'
@Component({
  name: 'App',
})
export default class extends Vue {
  created () {
    CommonMudule.getImgSourceAction()
  }

  // mounted () {()
  //   window.addEventListener('beforeunload', this.beforeunloadHandler)
  //   window.addEventListener('unload', this.unloadHandler)
  // }

  // destroyed () {
  //   window.removeEventListener('beforeunload', this.beforeunloadHandler)
  //   window.removeEventListener('unload', this.unloadHandler)
  // }

  // beforeunloadHandler (e: BeforeUnloadEvent) {
  //   e = e || window.event
  //   if (e) {
  //     e.returnValue = '关闭提示'
  //   }
  //   return '关闭提示'
  // }

  // async unloadHandler () {
  //   try {
  //     const from = {
  //       moduleCode: this.$route.meta.code,
  //       trackId: sessionGetItem('trackId')
  //     }
  //     const res = await visitSave(from)
  //     if (res?.data) {
  //       sessionSetItem('trackId', res.data.trackId)
  //     }
  //   } catch (error) {

  //   }
  // }
}
